import React from 'react'
import { useNavigate } from 'react-router-dom'

function MenuAtag({text,id,clickFn,idx}) {
    let navigate = useNavigate();
  return (
    <li><a href={`#${id}`} onClick={()=>{
        navigate("/");
        clickFn(id);
    }} data-idx={idx} >{text}</a></li>
  )
}

export default MenuAtag